import $models from '@/models'
import util from '@/util'
import moment from "@/moment-gp";
import clonedeep from "lodash.clonedeep";

import { make_block } from '@/components/TodayPage/API/util'

const log0 = (...args) => { /* console.log(...args) */};
const log1 = () => {};

export default {

  // ------------------------------------------------------------------------------------------------
  drag_item: state => {
    return state.drag_item;
  },

  drag_item_type: state => {
    return state.drag_item_type;
  },

  drag_target_date: state => {
    return state.drag_target_date;
  },

  drag_target_index: state => {
    return state.drag_target_index;
  },

  drag_active: state => {
    return state.drag_active;
  },

  drag_time_active: state => {
    return state.drag_time_active;
  },

  drag_time_selection: state => {
    return state.drag_time_selection;
  },

  drag_time_offset: state => {
    return state.drag_time_offset || 0;
  },

  // ------------------------------------------------------------------------------------------------
  drag_target_dayplan: (state, getters) => {
    if (getters.drag_target_date) {
      //let targetDate = getters.drag_target_date
      return getters.dayplan_from_db_at_date(getters.drag_target_date)
    }
    return null
  },

  drag_target_space: (state, getters) => {
    //console.log('drag_target_space()')
    let drag_target_space = null
    let draggablesList = getters.drag_target_draggables_list
    //console.log('drag_target_space draggablesList', draggablesList)
    //console.log('drag_target_space getters.drag_target_index', getters.drag_target_index, draggablesList, getters.drag_item)
    //console.log('drag_target_space getters.drag_target_draggables_list',  getters.drag_target_draggables_list, 'getters.drag_target_date', getters.drag_target_date )

    // if drag is an item inside the list
    //console.log('drag_target_space getters.drag_target_index', getters.drag_target_index)
    /*if (draggablesList && getters.drag_item) {
      //console.log('drag_target_space draggablesList.length', draggablesList.length, 'getters.drag_target_index', getters.drag_target_index)
      console.log('drag_target_space', getters.drag_target_date, draggablesList, getters.drag_target_index > 0, 'm1', getters.drag_target_index <= draggablesList.length, 'm2', getters.drag_item, getters.drag_item.dragConfig,  )
      console.log('drag_target_space getters.drag_target_index',getters.drag_target_index)
    }*/
    if (getters.drag_target_date
      && draggablesList
      && getters.drag_target_index >= 0
      && getters.drag_target_index <= draggablesList.length
      && getters.drag_item
      && getters.drag_item.dragConfig
      && !isNaN(getters.drag_item.dragConfig.duration)) {

      let newIndex = getters.drag_target_index
      //let targetDayplan = getters.drag_target_dayplan
      // change targetIndex to fit filtered list
      let maxIndex = newIndex
      //console.log('drag_target_space draggablesList.length',draggablesList.length)
      //console.log('drag_target_space newIndex before',newIndex)

      // only sessions and START_DAY, END_DAY information is stored in the database. Filter other types to get correct index
      for (let i = 0; i < maxIndex; i++) {
        if (draggablesList[i].type === 'CURRENT_TIME' || draggablesList[i].type === 'NOT_PLANNED') {
          newIndex -= 1
        }
      }
      // remove placeholders and the item itself, if it is in the same list
      let draggablesList_filtered = null
      if (getters.drag_item.type === 'TASKLIST'
        || getters.drag_item.type === 'TIME_BASED_TASKLIST'
        || getters.drag_item.type === 'SEQUENCE'
        || getters.drag_item.type === 'INLINE_TASK') {
        draggablesList_filtered = clonedeep(draggablesList)
          .filter(item => item.type !== 'CURRENT_TIME' && item.type !== 'NOT_PLANNED' && (!(item.sessionId) || !(getters.drag_item.sessionId) || item.sessionId !== getters.drag_item.sessionId))
      } else if (getters.drag_item.type === 'TASK'
        || getters.drag_item.type === 'START_DAY'
        || getters.drag_item.type === 'END_DAY') {
        draggablesList_filtered = clonedeep(draggablesList)
          .filter(item => item.type !== 'CURRENT_TIME' && item.type !== 'NOT_PLANNED')
      } else {
        return
      }
      // if timeslots selected, block all other times
      /*if (getters.drag_item.dragConfig.timeslots) {
        console.log('getters.drag_item.timeslots', getters.drag_item.dragConfig.timeslots)
      }*/
      //console.log('drag_target_space draggablesList_filtered',  draggablesList_filtered)
      //let shiftingEnabled = true
      newIndex = Math.min(draggablesList_filtered.length - 1, newIndex)
      //console.log('drag_target_space newIndex after',newIndex, getters.drag_item, draggablesList_filtered)
      let minFrom = null
      let maxTo = null
      if (newIndex === 0) {
        minFrom = clonedeep(getters.view_selected_date)
        .startOf("day")
        .unix()// - getters.drag_item.from
        maxTo = draggablesList_filtered[newIndex].from
      } else if (getters.drag_item.type === 'END_DAY') {
        minFrom = draggablesList_filtered[newIndex].from
        maxTo = clonedeep(getters.view_selected_date)
        .startOf("day").add(36, 'hour')
        .unix()// - getters.drag_item.from
      } else {
        minFrom = draggablesList_filtered[newIndex - 1].to
        maxTo = draggablesList_filtered[newIndex].from
      }
      // calculate minFrom with shifting of other session
      let draggablesList_filtered_copy = clonedeep(draggablesList_filtered)
      //console.log('draggablesList_filtered_copy', draggablesList_filtered_copy, newIndex)
      for (let i = 1; i < newIndex; i++) {
        //if (draggablesList_filtered_copy[i].from > draggablesList_filtered_copy[i - 1].to) {
          //console.log('draggablesList_filtered_copy i', i, draggablesList_filtered_copy[i].fixedFrom)
          if (!draggablesList_filtered_copy[i].fixedFrom && !draggablesList_filtered_copy[i].fixedTo) {
            let timeDifference = draggablesList_filtered_copy[i].from - draggablesList_filtered_copy[i - 1].to
            //console.log('drag_target_space index', i,' difference', timeDifference, ' before ', clonedeep(draggablesList_filtered_copy[i].to))
            draggablesList_filtered_copy[i].from -= timeDifference
            draggablesList_filtered_copy[i].to -= timeDifference
            //console.log('drag_target_space after', clonedeep(draggablesList_filtered_copy[i].to))
          }/* else {
            i = newIndex
          }*/
      }
      let minFromWithShifting = null
      if (newIndex === 0) {
        minFromWithShifting = minFrom
      } else {
        minFromWithShifting = draggablesList_filtered_copy[newIndex - 1].to
      }
      for (let i = draggablesList_filtered_copy.length - 2; i >= newIndex; i--) {
        //if (draggablesList_filtered_copy[i].from > draggablesList_filtered_copy[i - 1].to) {
          if (!draggablesList_filtered_copy[i].fixedFrom && !draggablesList_filtered_copy[i].fixedTo) {
            let timeDifference = draggablesList_filtered_copy[i + 1].from - draggablesList_filtered_copy[i].to
            draggablesList_filtered_copy[i].from += timeDifference
            draggablesList_filtered_copy[i].to += timeDifference
          } /*else {
            i = newIndex
          }*/
      }
      let maxToWithShifting = null
      if (getters.drag_item.type === 'END_DAY') {
        maxToWithShifting = clonedeep(getters.view_selected_date)
        .startOf("day").add(30, 'hour')
        .unix()
      } else {
        maxToWithShifting = draggablesList_filtered_copy[newIndex].from
      }

      let dragItemDuration = getters.drag_item.dragConfig.duration
      let sortidx = 0
      if (newIndex === 0) {
        sortidx = 0
      } else if (newIndex === 1) {
        sortidx = draggablesList_filtered_copy[1].sortidx / 2
      } else if (newIndex === draggablesList_filtered_copy.length - 1) {
        sortidx = (draggablesList_filtered_copy[draggablesList_filtered_copy.length - 2].sortidx + 1 ) / 2
      } else {
        sortidx = (draggablesList_filtered_copy[newIndex].sortidx + draggablesList_filtered_copy[newIndex - 1].sortidx) / 2
      }
      drag_target_space = {
        minFrom: minFrom,
        maxFrom: maxTo - dragItemDuration,
        maxTo: maxTo,
        minTo: minFrom + dragItemDuration,
        maxDuration: maxToWithShifting - minFromWithShifting,
        devMinFrom: moment(minFrom * 1000).format(),
        devMaxTo: moment(maxTo * 1000).format(),
        minFromWithShifting: minFromWithShifting,
        maxFromWithShifting: maxToWithShifting - dragItemDuration,
        minToWithShifting: minFromWithShifting + 5 * 60,
        maxToWithShifting: maxToWithShifting,
        devMinFromWithShifting: moment(minFromWithShifting * 1000).format(),
        devMaxToWithShifting: moment(maxToWithShifting * 1000).format(),
        newIndex: newIndex,
        sortidx: sortidx,
        devDragItemDuration: dragItemDuration
      }
      //console.log('new drag_target_space', drag_target_space)
    }
    return drag_target_space
  },

  drag_target_status_ok: (state, getters) => {
    let drag_target_space = getters.drag_target_space
    if (getters.drag_item && drag_target_space && getters.drag_item.dragConfig) {
      //console.log('drag_target_status_ok', drag_target_space.maxDuration,  getters.drag_item.to, getters.drag_item.from, getters.drag_item)
      if (drag_target_space.maxDuration >= getters.drag_item.dragConfig.duration) {
        return true
      } else {
        return false
      }
    }
    return null
  },

  drag_item_placement: (state, getters) => {
    let dragItemPlacement = null
    let dragTargetSpace = getters.drag_target_space

    if (getters.drag_time_active) {
      //console.log('drag_item_placement marker 1')
      if (getters.drag_item && dragTargetSpace) {
        let fromOffset = 0
        let newFrom = 0
        let newTo = 0
        if (!getters.drag_time_selection) {
          let dragItem = getters.drag_item
          let duration = dragItem.dragConfig.duration
          if (dragTargetSpace.maxTo - dragTargetSpace.minFrom  >= duration) {
            newFrom = dragTargetSpace.minFrom
            newTo = dragTargetSpace.minFrom + duration
          } else if (dragTargetSpace.maxToWithShifting - dragTargetSpace.minFrom  >= duration) {
            newFrom = dragTargetSpace.minFrom
            newTo = dragTargetSpace.minFrom + duration
          } else if (dragTargetSpace.maxTo - dragTargetSpace.minFromWithShifting  >= duration) {
            newFrom = dragTargetSpace.maxTo - duration
            newTo = dragTargetSpace.maxTo
          } else if (dragTargetSpace.maxToWithShifting - dragTargetSpace.minFromWithShifting  >= duration) {
            newFrom = dragTargetSpace.maxToWithShifting - duration
            newTo = dragTargetSpace.maxToWithShifting
          }
        } else if (getters.drag_time_selection === 'from') {
          if (getters.drag_item.fixedTo) {
            newFrom = Math.min(getters.drag_item.to - 5 * 60, Math.round(Math.min(dragTargetSpace.maxFromWithShifting, Math.max(dragTargetSpace.minFromWithShifting, getters.drag_item.from + getters.drag_time_offset)) / 300) * 300)
            fromOffset =  newFrom - getters.drag_item.from
            newTo = getters.drag_item.to
          } else {
            newFrom = Math.round(Math.min(dragTargetSpace.maxFromWithShifting, Math.max(dragTargetSpace.minFromWithShifting, getters.drag_item.from + getters.drag_time_offset)) / 300) * 300
            fromOffset =  newFrom - getters.drag_item.from
            newTo = getters.drag_item.to + fromOffset
          }
        } else if (getters.drag_time_selection === 'to') {
          newFrom = getters.drag_item.from
          newTo = Math.round(Math.min(dragTargetSpace.maxToWithShifting, Math.max(getters.drag_item.from + 5 * 60, getters.drag_item.to + getters.drag_time_offset)) / 300) * 300
        } else if (getters.drag_time_selection === 'START_DAY') {
          newFrom = Math.round(Math.max(dragTargetSpace.minFromWithShifting, Math.min(dragTargetSpace.maxToWithShifting, getters.drag_item.from + getters.drag_time_offset)) / 300) * 300
          newTo =  newFrom
        } else if (getters.drag_time_selection === 'END_DAY') {
          newFrom = Math.round(Math.max(dragTargetSpace.minFromWithShifting, Math.min(dragTargetSpace.maxToWithShifting, getters.drag_item.from + getters.drag_time_offset)) / 300) * 300
          newTo =  newFrom
        }
        dragItemPlacement = {
          from: newFrom,
          to: newTo ,
          devFrom: moment(1000 * newFrom).format(),
          devTo: moment(1000 * newTo).format(),
          sortidx: dragTargetSpace.sortidx
        }
      }
    } else {
      //console.log('drag_item_placement marker 2')
      if (getters.drag_item && getters.drag_target_status_ok && dragTargetSpace) {
        let dragItem = getters.drag_item
        let duration = dragItem.dragConfig.duration
        if (dragTargetSpace.maxTo - dragTargetSpace.minFrom  >= duration) {
          let dragItemConfig = getters.drag_item.dragConfig
          if (dragItemConfig.placeAtEnd) {
            dragItemPlacement = {
              from: dragTargetSpace.maxTo - (duration),
              to: dragTargetSpace.maxTo,
              devFrom: moment(1000 * (dragTargetSpace.maxTo - (duration))).format(),
              devTo: moment(1000 * dragTargetSpace.maxTo).format(),
              sortidx: dragTargetSpace.sortidx
            }
          } else {
            dragItemPlacement = {
              from: dragTargetSpace.minFrom,
              to: dragTargetSpace.minFrom + (duration),
              devFrom: moment(1000 * dragTargetSpace.minFrom).format(),
              devTo: moment(1000 * (dragTargetSpace.minFrom + (duration))).format(),
              sortidx: dragTargetSpace.sortidx
            }
          }
        } else if (dragTargetSpace.maxToWithShifting - dragTargetSpace.minFrom  >= duration ) {
          dragItemPlacement = {
            from: dragTargetSpace.minFrom,
            to: dragTargetSpace.minFrom + (duration),
            devFrom: moment(1000 * dragTargetSpace.minFrom).format(),
            devTo: moment(1000 * (dragTargetSpace.minFrom + (duration))).format(),
            sortidx: dragTargetSpace.sortidx
          }
        } else if (dragTargetSpace.maxToWithShifting - dragTargetSpace.minFromWithShifting  >= duration ) {
          dragItemPlacement = {
            from: dragTargetSpace.maxToWithShifting - (duration),
            to: dragTargetSpace.maxToWithShifting,
            devFrom: moment(1000 * (dragTargetSpace.maxToWithShifting - (duration))).format(),
            devTo: moment(1000 * (dragTargetSpace.maxToWithShifting)).format(),
            sortidx: dragTargetSpace.sortidx
          }
        }
      }
    }
    return dragItemPlacement
  },

  dayplan_virtual_offsets: (state, getters) => {
    //console.log('dayplan_virtual_offsets()')
    let dayplan_virtual_offsets = {}

    let draggablesList = getters.drag_target_draggables_list
    if (draggablesList && getters.drag_item) {
      let newIndex = getters.drag_target_index
      let maxIndex = newIndex
      for (let i = 0; i < maxIndex; i++) {
        if (draggablesList[i].type === 'CURRENT_TIME' || draggablesList[i].type === 'NOT_PLANNED') {
          newIndex -= 1
        }
      }
      // remove placeholders and the item itself, if it is in the same list
      let draggablesListCopy_without_placeholders = clonedeep(draggablesList)
      .filter(item => item.type !== 'CURRENT_TIME'
        && item.type !== 'NOT_PLANNED'
        //&& item.sessionId !== getters.drag_item.sessionId
        )
      newIndex = Math.min(draggablesListCopy_without_placeholders.length - 1, newIndex)
      // update all times of items that where moved due to shifting
      //build copy and calculate how far each object could be moved
      for (let i = 0; i < draggablesListCopy_without_placeholders.length; i++) {
        let session = draggablesListCopy_without_placeholders[i];
        let minFrom = 0;
        let maxFrom = 0;
        let minTo = session.from - session.to + 5 * 60;
        let maxTo = 0;
        if (
          session.type === "TASKLIST"    ||
          session.type === "TIME_BASED_TASKLIST" ||
          session.type === "SEQUENCE"    ||
          session.type === "INLINE_TASK" ||
          session.type === "START_DAY"   ||
          session.type === "END_DAY"
        ) {
          let index = null;

          if (session.type === "TASKLIST" || session.type === "TIME_BASED_TASKLIST" || session.type === "SEQUENCE" || session.type === "INLINE_TASK") {
            index = session.sessionId;
            minFrom = draggablesListCopy_without_placeholders[i - 1].to - session.from;
            if (session.fixedDuration) {
              //log2('getters.drag_item fixedDuration true', draggablesListCopy_without_placeholders[i + 1].from )
              maxFrom =
                draggablesListCopy_without_placeholders[i + 1].from - session.from - (session.to - session.from);
              maxTo = draggablesListCopy_without_placeholders[i + 1].from - session.to;
            } else {
              //log2('getters.drag_item fixedDuration false')
              maxFrom = draggablesListCopy_without_placeholders[i + 1].from - session.from - 5 * 60;
              maxTo = draggablesListCopy_without_placeholders[i + 1].from - session.to;
            }
            //log2('getters.drag_item', minFrom, maxFrom, minTo, maxTo)
          }

          if (session.type === "START_DAY") {
            index = "START_DAY";
            if (getters.drag_item.type === 'START_DAY') {
              minFrom = getters.drag_item_placement.from
              maxFrom = getters.drag_item_placement.to
            } else {
              minFrom = draggablesListCopy_without_placeholders[0].from
              minTo = draggablesListCopy_without_placeholders[0].to
            }
          }
          if (session.type === "END_DAY") {
            index = "END_DAY";
            if (getters.drag_item.type === 'END_DAY') {
              minFrom = getters.drag_item_placement.from
              maxFrom = getters.drag_item_placement.to
            } else {
            minFrom = draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].from
            minTo = draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].to
            }
          }
          /*
          if (session.type === "END_DAY") {
            index = "END_DAY";
            minFrom = -(
              draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].from -
              draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 2].to
            );
            maxFrom =
              clonedeep(moment(1000 * draggablesListCopy_without_placeholders[i].from))
                .startOf("day")
                .add(24, "hour")
                .unix() - draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].from;
          }*/

          dayplan_virtual_offsets[index] = {
            from: 0,
            to: 0,
            duration: 0,
            minFrom: minFrom,
            maxFrom: maxFrom,
            minTo: minTo,
            maxTo: maxTo,
            type: session.type,
            sessionId: session.sessionId || null
            //minDuration: 5 * 60,
            //maxDuration: 60 * 60
          };
        }
      }

      //console.log('dayplan_virtual_offsets1', clonedeep(dayplan_virtual_offsets), getters.drag_time_selection)

      if (getters.drag_time_selection) {
        let draggablesListVirtualOffsetItem = null;
        let fromOffset = 0;
        let toOffset = 0;

        if (!dayplan_virtual_offsets[getters.drag_item.sessionId] && getters.drag_item.type !== "START_DAY" && getters.drag_item.type !== "END_DAY") {
          return
        }
        if (getters.drag_time_selection === "from") {
          draggablesListVirtualOffsetItem = dayplan_virtual_offsets[getters.drag_item.sessionId];
          //if (getters.drag_item.fixedDuration ) {
          //log2('getters.drag_item.from', getters.drag_item.from)
          fromOffset = Math.max(
            draggablesListVirtualOffsetItem.minFrom,
            Math.min(
              draggablesListVirtualOffsetItem.maxFrom,
              getters.drag_time_offset - ((getters.drag_item.from + getters.drag_time_offset) % 300)
            )
          );
          if (fromOffset > 0) {
            toOffset = Math.max(
              draggablesListVirtualOffsetItem.minTo,
              Math.min(draggablesListVirtualOffsetItem.maxTo, fromOffset)
            );
          } else {
            toOffset = fromOffset;
          }
          //}
        } else if (getters.drag_time_selection === "to") {
          draggablesListVirtualOffsetItem = dayplan_virtual_offsets[getters.drag_item.sessionId];
          //toOffset = getters.drag_time_offset
          //fromOffset = getters.drag_time_offset - (session.from + getters.drag_time_offset) % 300 // 5 minute grid
          toOffset = Math.max(
            draggablesListVirtualOffsetItem.minTo,
            Math.min(
              draggablesListVirtualOffsetItem.maxTo,
              getters.drag_time_offset - ((getters.drag_item.to + getters.drag_time_offset) % 300)
            )
          );
        } else if (getters.drag_time_selection === "START_DAY") {
          //console.log('dayplan_virtual_offsets() START_DAY')
          //draggablesListVirtualOffsetItem = dayplan_virtual_offsets["START_DAY"];
          /*if (!dayplan_virtual_offsets["START_DAY"]) {
            dayplan_virtual_offsets["START_DAY"] = {}
          }*/
          //console.log('getters.drag_time_offset', getters.drag_time_offset)
          fromOffset = getters.drag_item_placement.from - getters.drag_item.from /*Math.max(
            draggablesListVirtualOffsetItem.minFrom,
            Math.min(
              draggablesListVirtualOffsetItem.maxFrom,
              getters.drag_time_offset - ((getters.drag_item.from + getters.drag_time_offset) % 300)
            )
          );*/
          toOffset = fromOffset
        } else if (getters.drag_time_selection === "END_DAY") {
          //console.log('dayplan_virtual_offsets() END_DAY')
          //draggablesListVirtualOffsetItem = dayplan_virtual_offsets["END_DAY"];
          fromOffset = getters.drag_item_placement.from - getters.drag_item.from /*Math.max(
            draggablesListVirtualOffsetItem.minFrom,
            Math.min(
              draggablesListVirtualOffsetItem.maxFrom,
              getters.drag_time_offset - ((getters.drag_item.from + getters.drag_time_offset) % 300)
            )
          );*/
          toOffset = fromOffset
        }

        let durationOffset = toOffset - fromOffset;
        if (getters.drag_time_selection === "from" || getters.drag_time_selection === "to") {
          dayplan_virtual_offsets[getters.drag_item.sessionId].from += fromOffset;
          dayplan_virtual_offsets[getters.drag_item.sessionId].to += toOffset;
          dayplan_virtual_offsets[getters.drag_item.sessionId].duration += durationOffset;
        } else if (getters.drag_time_selection === "START_DAY") {
          /*if (!dayplan_virtual_offsets["START_DAY"]) {
            dayplan_virtual_offsets["START_DAY"] = {}
          }*/
          dayplan_virtual_offsets["START_DAY"].from += fromOffset;
          dayplan_virtual_offsets["START_DAY"].to += fromOffset;
          dayplan_virtual_offsets["START_DAY"].newFrom = draggablesListCopy_without_placeholders[0].from + fromOffset
          dayplan_virtual_offsets["START_DAY"].newTo = draggablesListCopy_without_placeholders[0].from + fromOffset
           /* dayplan_virtual_offsets["START_DAY"].from += fromOffset;
            dayplan_virtual_offsets["START_DAY"].to += fromOffset;
            dayplan_virtual_offsets["START_DAY"].newFrom = draggablesListCopy_without_placeholders[0].from + fromOffset
            dayplan_virtual_offsets["START_DAY"].newTo = draggablesListCopy_without_placeholders[0].from + fromOffset*/
        } else if (getters.drag_time_selection === "END_DAY") {
          dayplan_virtual_offsets["END_DAY"].from += fromOffset;
          dayplan_virtual_offsets["END_DAY"].to += fromOffset;
          dayplan_virtual_offsets["END_DAY"].newFrom = draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].from + fromOffset
          dayplan_virtual_offsets["END_DAY"].newTo = draggablesListCopy_without_placeholders[draggablesListCopy_without_placeholders.length - 1].from + fromOffset
        }
      }
      if (getters.drag_item_placement) {
          dayplan_virtual_offsets[getters.drag_item.sessionId] = {
            from: getters.drag_item_placement.from - getters.drag_item.from,
            to: getters.drag_item_placement.to - getters.drag_item.to,
            duration: (getters.drag_item_placement.to - getters.drag_item_placement.from) - (getters.drag_item.to - getters.drag_item.from),
            newFrom: getters.drag_item_placement.from,
            newTo: getters.drag_item_placement.to,
            type: getters.drag_item.type,
            sessionId: getters.drag_item.sessionId || null
          }
          if (draggablesListCopy_without_placeholders[newIndex].sessionId === getters.drag_item.sessionId) {
            draggablesListCopy_without_placeholders[newIndex].from += getters.drag_item_placement.from - draggablesListCopy_without_placeholders[newIndex].from
            draggablesListCopy_without_placeholders[newIndex].to += getters.drag_item_placement.to - draggablesListCopy_without_placeholders[newIndex].to
          }
      }

      // change position of element in draggablesListCopy_without_placeholders
      /*console.log('draggablesListCopy_without_placeholders before', draggablesListCopy_without_placeholders)
      for (let i = 0; i < draggablesListCopy_without_placeholders.length; i++) {
        if (draggablesListCopy_without_placeholders[i].sessionId === getters.drag_item.sessionId) {
          console.log('draggablesListCopy_without_placeholders element found')
          var element = clonedeep(draggablesListCopy_without_placeholders[i]);
          draggablesListCopy_without_placeholders.splice(i, 1);
          draggablesListCopy_without_placeholders.splice(newIndex, 0, element);
        }
      }*/
      //console.log('draggablesListCopy_without_placeholders after', draggablesListCopy_without_placeholders)

      log1('draggablesListCopy_without_placeholders', clonedeep(draggablesListCopy_without_placeholders))
      //console.log('movelist1', dayplan_virtual_offsets, newIndex, draggablesListCopy_without_placeholders.length)
      if (getters.drag_item && getters.drag_item_placement) {
        //update from/to time of items after the inserted item
        //console.log('movelist2')
        for (let i = newIndex; i < draggablesListCopy_without_placeholders.length; i++) {
          if (i === newIndex) {
            if (getters.drag_item_placement.to > draggablesListCopy_without_placeholders[i].from) {
              if (draggablesListCopy_without_placeholders[i].sessionId !== getters.drag_item.sessionId) {
                let offset = getters.drag_item_placement.to - draggablesListCopy_without_placeholders[i].from
                dayplan_virtual_offsets[draggablesListCopy_without_placeholders[i].sessionId] = {
                  from: offset,
                  to: offset,
                  duration: 0,
                  newFrom: draggablesListCopy_without_placeholders[i].from + offset,
                  newTo: draggablesListCopy_without_placeholders[i].to + offset,
                  devNewDuration: draggablesListCopy_without_placeholders[i].to - draggablesListCopy_without_placeholders[i].from,
                  type: draggablesListCopy_without_placeholders[i].type,
                  sessionId: draggablesListCopy_without_placeholders[i].sessionId || null,
                }

                draggablesListCopy_without_placeholders[i].from += offset
                draggablesListCopy_without_placeholders[i].to += offset
              }
            }
          } else if (draggablesListCopy_without_placeholders[i - 1].to > draggablesListCopy_without_placeholders[i].from) {
            if (draggablesListCopy_without_placeholders[i].sessionId !== getters.drag_item.sessionId) {
              let offset = draggablesListCopy_without_placeholders[i - 1].to - draggablesListCopy_without_placeholders[i].from
              dayplan_virtual_offsets[draggablesListCopy_without_placeholders[i].sessionId] = {
                from: offset,
                to: offset,
                duration: 0,
                newFrom: draggablesListCopy_without_placeholders[i].from + offset,
                newTo: draggablesListCopy_without_placeholders[i].to + offset,
                devNewDuration: draggablesListCopy_without_placeholders[i].to - draggablesListCopy_without_placeholders[i].from,
                type: draggablesListCopy_without_placeholders[i].type,
                sessionId: draggablesListCopy_without_placeholders[i].sessionId || null
              }

              draggablesListCopy_without_placeholders[i].from += offset
              draggablesListCopy_without_placeholders[i].to += offset
            }
          }
        }
        for (let i = newIndex; i > 0; i--) {
          //console.log('movelist1 m3', i,draggablesListCopy_without_placeholders)
          if (i === newIndex) {
            if (getters.drag_item_placement.from < draggablesListCopy_without_placeholders[i - 1].to) {
              if (draggablesListCopy_without_placeholders[i - 1].sessionId !== getters.drag_item.sessionId) {
                let offset = getters.drag_item_placement.from - draggablesListCopy_without_placeholders[i - 1].to
                dayplan_virtual_offsets[draggablesListCopy_without_placeholders[i - 1].sessionId] = {
                  from: offset,
                  to: offset,
                  duration: offset,
                  newFrom: draggablesListCopy_without_placeholders[i - 1].from + offset,
                  newTo: draggablesListCopy_without_placeholders[i - 1].to + offset,
                  type: draggablesListCopy_without_placeholders[i - 1].type,
                  sessionId: draggablesListCopy_without_placeholders[i - 1].sessionId || null
                }

                draggablesListCopy_without_placeholders[i - 1].from += offset
                draggablesListCopy_without_placeholders[i - 1].to += offset
              }
            }
          } else if (draggablesListCopy_without_placeholders[i].from < draggablesListCopy_without_placeholders[i - 1].to) {
            //console.log('movelist1 m4', i)
            if (draggablesListCopy_without_placeholders[i - 1].sessionId !== getters.drag_item.sessionId) {
              let offset = draggablesListCopy_without_placeholders[i].from - draggablesListCopy_without_placeholders[i - 1].to
                dayplan_virtual_offsets[draggablesListCopy_without_placeholders[i - 1].sessionId] = {
                  from: offset,
                  to: offset,
                  duration: offset,
                  newFrom: draggablesListCopy_without_placeholders[i - 1].from + offset,
                  newTo: draggablesListCopy_without_placeholders[i - 1].to + offset,
                  type: draggablesListCopy_without_placeholders[i - 1].type,
                  sessionId: draggablesListCopy_without_placeholders[i - 1].sessionId || null
                }
              draggablesListCopy_without_placeholders[i - 1].from += offset
              draggablesListCopy_without_placeholders[i - 1].to += offset
            }
          }
        }
      }

      // add placeholders
      let draggablesListCopyForPlaceholders = null;
      let draggablesListCopy = clonedeep(draggablesList)/*.filter(session => session.type !== "CURRENT_TIME");*/
      draggablesListCopyForPlaceholders = draggablesListCopy;

      //console.log('draggablesListCopyForPlaceholders', draggablesListCopyForPlaceholders)
      for (let i = 1; i < draggablesListCopyForPlaceholders.length - 1; i++) {

        let session = draggablesListCopyForPlaceholders[i];
        if (session.type === "NOT_PLANNED") {
          let from = null;
          let to = null;

          //log2('draggablesListCopyForPlaceholders', i, 'dayplan_virtual_offsets:', dayplan_virtual_offsets, 'draggablesListCopyForPlaceholders:',draggablesListCopyForPlaceholders)
          if (draggablesListCopyForPlaceholders[i - 1].type === "START_DAY") {
            //log2('draggablesListCopyForPlaceholders A', clonedeep(draggablesListCopyForPlaceholders), clonedeep(dayplan_virtual_offsets), dayplan_virtual_offsets['START_DAY'].to)
            from = clonedeep(dayplan_virtual_offsets["START_DAY"].to);
          } else {
            //log2('draggablesListCopyForPlaceholders B', clonedeep(draggablesListCopyForPlaceholders), clonedeep(dayplan_virtual_offsets), draggablesListCopyForPlaceholders[i - 1].sessionId, dayplan_virtual_offsets[draggablesListCopyForPlaceholders[i - 1].sessionId].to)
            from = clonedeep(dayplan_virtual_offsets[draggablesListCopyForPlaceholders[i - 1].sessionId].to);
          }

          if (draggablesListCopyForPlaceholders[i + 1].type === "END_DAY") {
            //log2('draggablesListCopyForPlaceholders C', clonedeep(draggablesListCopyForPlaceholders), clonedeep(dayplan_virtual_offsets), dayplan_virtual_offsets['END_DAY'].from)
            to = clonedeep(dayplan_virtual_offsets["END_DAY"].from);
          } else {
            //log2('draggablesListCopyForPlaceholders D', clonedeep(draggablesListCopyForPlaceholders), clonedeep(dayplan_virtual_offsets), draggablesListCopyForPlaceholders[i + 1].sessionId, dayplan_virtual_offsets[draggablesListCopyForPlaceholders[i + 1].sessionId].from)
            //console.log('xxx', dayplan_virtual_offsets, draggablesListCopyForPlaceholders.length, i + 1)
            to = clonedeep(dayplan_virtual_offsets[draggablesListCopyForPlaceholders[i + 1].sessionId].from);
          }

          dayplan_virtual_offsets[i] = {
            from: from,
            to: to,
            duration: to - from
          };
        }
      }
    }
    return dayplan_virtual_offsets
  },
  // drag_time_active: state => { // TODO: Move back to component
  //   // dragTimeActive
  //   return state.drag_time_active;
  // },

  column_layout: state => {
    return state.column_layout;
  },

  show_nothing_planned: state => {
    return state.show_nothing_planned;
  },

  show_reduced_dayplan: state => {
    return state.show_reduced_dayplan;
  },

  // Support current selection in sidebar

  // ------------------------------------------------------------------------------------------------

  /*
  *
  */
  view_selected_date: state => {
    return moment.fromStore( state.view_selected );
  },

  view_selected_date_as_timestamp: (state, getters) => {
    return getters.view_selected_date.unix();
  },

  view_selected_date_as_yymmdd: (state, getters) => {
    return getters.view_selected_date.format('YYMMDD');
  },

  /*
  *
  */
  view_from_date: state => {
    return moment.fromStore( state.view_from );
  },

  view_from_date_as_timestamp: (state, getters) => {
    return getters.view_from_date.unix();
  },

  view_from_date_as_yymmdd: (state, getters) => {
    return getters.view_from_date.format('YYMMDD');
  },

  /*
  *
  */
  view_to_date: state => {
    return moment.fromStore( state.view_to );
  },

  view_to_date_as_timestamp: (state, getters) => {
    return getters.view_to_date.unix();
  },

  view_to_date_as_yymmdd: (state, getters) => {
    return getters.view_to_date.format('YYMMDD');
  },

  /*
  *
  */
  view_is_multi_day: (state, getters) => {
    // TODO: ... or week view
    return state.view_to !== null &&
      getters.view_from_date.diff( getters.view_to_date, 'days' ) !== 0;
  },

  // ------------------------------------------------------------------------------------------------

  /*
  *
  */
  show_backlog_by_session_id: state => (session_id) => {
    return !!state.show_backlog_list[ session_id ];
  },

  // ------------------------------------------------------------------------------------------------

  /*
  *
  */
  dayplanner_sessions() {
    /// TODO !!!!
    return $models.userDayplannerSessions.subscribeQuery({
      key: "dateString",
      startAt: "190601", //moment.currentDate().clone().subtract(10,'day').format('YYMMDD'), // <<<
      limit: 250         // <<<
    });
  },

  /* - Internal use only -
  *
  */
  commitment_data: state => {
    return state.commitment_data_cache
  },

  /*
  *
  */
  dayplan_from_db_at_selected_day: (state, getters) =>  {
    if (state.view_selected_date) {
      console.log('dayplan_from_db_at_date vorher:', state.view_selected_date)
      return getters.dayplan_from_db_at_date(state.view_selected_date);
    } else {
      return null
    }
  },

  /*
  * TODO: This getter is not cached!
  *
  */
  dayplan_from_db_at_date: (state, getters) => dateString => {

    //console.log('dayplan_from_db_at_date dateString:', dateString)
    if (!getters.dayplanner_sessions.$readyAll || !getters.commitment_data || !dateString) {
      return []
    }

    let dayplan_from_db = [];
    let sessions = getters.dayplanner_sessions
      .itemsAsArray()
      // .filter(session => session.dateString === getters.view_current_date_as_yymmdd)
      .filter(session => session.dateString === dateString && session.from)
      .sort(util.sorter.by_sortidx);

    let startDayObj = clonedeep(sessions).filter(session => session.$state.type === "START_DAY");
    let endDayObj = clonedeep(sessions).filter(session => session.$state.type === "END_DAY");

    if (startDayObj && startDayObj[0]) {
      dayplan_from_db.push({
        sessionId: startDayObj[0].$id,
        type: startDayObj[0].$state.type,
        from: startDayObj[0].$state.from,
        to: startDayObj[0].$state.from,
        title: "Start of day",
        no_drag: false,
        component: "flow-day-marker",
        sortidx: 0,
      });
    } else {
      dayplan_from_db.push({
        type: "START_DAY",
        // from: getters.view_current_date
        from: moment(dateString, 'YYMMDD')
          .clone()
          .add(7, "hour")
          .unix(),
        to: moment(dateString, 'YYMMDD')
        .clone()
        .add(7, "hour")
        .unix(),
        title: "Start of day",
        no_drag: false,
        component: "flow-day-marker",
        sortidx: 0,
      });
    }

    function get_component_name( session ) {
      if ( session.type === 'TIME_BASED_TASKLIST' ) {
        return 'flow-tasklist';
      }
      return 'flow-' + session.type.toLowerCase()
    }

    for (let i = 0; i < sessions.length; i++) {
      let session = sessions[i];

      if ( session.type !== "START_DAY"
        && session.type !== "END_DAY"
        && getters.commitment_data[session.commitmentId] ) {

        // TODO: Use make_block
        let item = {
          sessionId: session.$id,
          type:      session.type,
          title:     getters.commitment_data[session.commitmentId].name,
          from:      session.from.unix(),
          to:        session.to.unix(),
          config: {
            goalId:       getters.commitment_data[session.commitmentId].goalId,
            commitmentId: session.commitmentId,
            tscId:        getters.commitment_data[session.commitmentId].tscId,
            tscColor:     getters.commitment_data[session.commitmentId].tscColor,
          },
          component:     get_component_name( session ),
          sortidx:       session.sortidx,
          sequenceItems: session.sequenceItems || [],
          fixedFrom:     session.fixedFrom || false,
          fixedTo:       session.fixedTo || false,
          fixedDuration: session.fixedDuration || false,
        };
        dayplan_from_db.push(item);
      }

      // TODO: Habit, Amount
      if ( session.type === 'INLINE_TASK' ) {

        let config = Object.assign({
          title: 'undefined',
          icon:  '/img/undefined.svg',
        }, session.config );

        let block = make_block(
          session.type,
          null,
          null,
          'DELME', // config.title,
          config
        );

        // TODO: move to make_block
        block.from      = session.from.unix()
        block.to        = session.to.unix()
        block.sortidx   = session.sortidx;
        block.sessionId = session.$id;

        dayplan_from_db.push(block);
      }
    }

    if (endDayObj && endDayObj[0]) {
      dayplan_from_db.push({
        sessionId: endDayObj[0].$id,
        type:      endDayObj[0].$state.type,
        from:      endDayObj[0].$state.from,
        to:        endDayObj[0].$state.from, // from on purpose. no mistake
        title:     "End of day",
        no_drag:   false,
        component: "flow-day-marker",
        sortidx:   1,
      });
    } else {
      dayplan_from_db.push({
        type: "END_DAY",
        // from: getters.view_current_date
        from: moment(dateString, 'YYMMDD')
          .clone()
          .add(23, "hour")
          .unix(),
        to: moment(dateString, 'YYMMDD')
          .clone()
          .add(23, "hour")
          .unix(),
        title:     "End of day",
        no_drag:   false,
        component: "flow-day-marker",
        sortidx:   1,
      });
    }

    /*dayplan_from_db.push({
        type: "NEXT_DAY",
        from: view_date.clone().add(31,'hour').unix(),
        to: view_date.clone().add(31,'hour').unix(),
        title: "Next day",
        no_drag: true,
        "component": "flow-day-marker",
        sortidx: 1
      })*/

    return dayplan_from_db;
  },

  drag_target_draggables_list: (state, getters) => {
    if (getters.drag_target_date) {
      return getters.draggables_list_at_date(getters.drag_target_date)
    } else {
      return null
    }
  },

  /*
  * TODO: This getter is not cached!
  *
  */
  draggables_list_at_date: (state, getters) => view_date => {

    //console.log('draggables_list_at_date', view_date)
     // TODO: 1 item in list
    if (!view_date) {
      return [];
    }
    let dayplan = getters.dayplan_from_db_at_date(view_date);
    //console.log('draggables_list_at_date dayplan', dayplan)
    if (dayplan.length === 0) {
      return [];
    }
    // dayplan = dayplan.sort(util.sorter.by_from);
    let current_time = dayplan[0].from; // TODO: Wake up time
    for (let i = 0; i < dayplan.length; i++) {
      let item = dayplan[i];
      item.devCurrentTime = moment.unix(current_time).format("LT");
      item.devFrom = moment.unix(item.from).format("LT");
      item.devTo = moment.unix(item.to).format("LT");
    }

    // TODO: function fillUpWithPlaceholders()
    // TODO: Insert pauses - optional via toggle
    let draggablesList = [];
    let nrPlaceholders = 1;

    for (let idx = 0; idx < dayplan.length - 1; idx++) {
      let currentBlock = dayplan[idx];
      let nextBlock = dayplan[idx + 1];

      if (currentBlock.type === "NOT_PLANNED") {
        // Remove previous pauses! (Redundant)
        continue;
      }

      currentBlock.original_idx = idx; // Side effect: TODO
      draggablesList.push(currentBlock);

      if (!currentBlock.to) {
        // not required anymore
        // Some blocks don't have a to date
        currentBlock.to = currentBlock.from;
      }

      // HACK: insert current time block
      let current_time_block = null;
      if (dayplan.length === 2 && idx === 0) {
        // Show Only today
        if (moment(view_date * 1000).diff(moment.currentDate(), "days") === 0) {
          current_time_block = make_block("CURRENT_TIME", null, null, "");
          current_time_block.to = moment.currentTime().unix(); // TODO: Auto-Update
          current_time_block.from = current_time_block.to;
          draggablesList.push(current_time_block);
        }
      }

      if (nextBlock.from - currentBlock.to > 0) {
        // TODO: update placeholders in live drag
          let placeholder = make_block("NOT_PLANNED", null, null, "Idling...");
          placeholder.idx = idx + nrPlaceholders++;
          placeholder.from = current_time_block ? current_time_block.to : currentBlock.to;
          placeholder.to = nextBlock.from;
          placeholder.devFrom = moment(placeholder.from * 1000).format()
          placeholder.devTo = moment(placeholder.to * 1000).format()
          draggablesList.push(placeholder);
      }
    }

    let lastBlock = dayplan.pop();
    lastBlock.original_idx = dayplan.length;
    draggablesList.push(lastBlock);

    log1("[DayplanEditor] DAYPLAN", draggablesList);
    return draggablesList; // maybe return dayplan
  },
  // ------------------------------------------------------------------------------------------------

  /*
  *
  */
  dayplan_max_sortidx: (state, getters) => {
    let dayplan_max_sortidx = 1;
    if ( getters.dayplan_from_db_at_selected_day ) {
      for (let i = 0; i < getters.dayplan_from_db_at_selected_day.length; i++) {
        let event = getters.dayplan_from_db_at_selected_day[i];

        log1("dayplan_max_sortidx", event);
        if (event.sortidx && event.sortidx > dayplan_max_sortidx) {
          dayplan_max_sortidx = event.sortidx;
        }
      }
    }
    return dayplan_max_sortidx;
  },

  // ------------------------------------------------------------------------------------------------

  /*
  *
  */
  dayplan_remaining_timeslots: (state, getters) => {
    if ( !getters.dayplan_from_db_at_selected_day ) {
      return [];
    }

    let timeslots = [];
    let wakeupTime = getters.view_selected_date
      .clone()
      .startOf("day")
      .unix();
    let bedTime = getters.view_selected_date
      .clone()
      .endOf("day")
      .unix() + 1;

    let wakeupObj = getters.dayplan_from_db_at_selected_day.filter(item => item.type === "START_DAY");
    if (wakeupObj && wakeupObj[0] && wakeupObj[0].from) {
      wakeupTime = wakeupObj[0].from;
    }
    let bedTimeObj = getters.dayplan_from_db_at_selected_day.filter(item => item.type === "END_DAY");
    if (bedTimeObj && bedTimeObj[0] && bedTimeObj[0].from) {
      bedTime = bedTimeObj[0].from;
    }

    log0(
      "wakeupTime",
      moment.unix(wakeupTime).format("LT"),
      "bedTime",
      moment.unix(bedTime).format("LT"),
      wakeupObj,
      bedTimeObj
    );

    let tmpCurrentTime = wakeupTime;
    let tmpSortIdxFrom = 0;
    let tmpSortIdxTo = 0;

    log1('dayplan_remaining_timeslots', clonedeep(getters.dayplan_from_db_at_selected_day).sort(util.sorter.by_from))

    clonedeep(getters.dayplan_from_db_at_selected_day)
      .sort(util.sorter.by_from)
      .forEach(item => {
        log0(
          "dayplan_remaining_timeslots item found:",
          item,
          "currentTime",
          tmpCurrentTime,
          moment(item.from * 1000).format(),
          moment(tmpCurrentTime * 1000).format()
        );

        if (item.type === "NOT_PLANNED") {
          return;
        }

        let to = Math.min(bedTime, item.from);
        if (item.sortidx) {
          tmpSortIdxFrom = tmpSortIdxTo;
          tmpSortIdxTo = item.sortidx;
        }

        if (item.from - tmpCurrentTime > 0 && item.type !== "START_DAY") {

          log1("dayplan_remaining_timeslots time found:", to - tmpCurrentTime);

          timeslots.push({
            from: tmpCurrentTime,
            to: to,
            devFrom: moment.unix(tmpCurrentTime).format("LT"),
            devTo: moment.unix(to).format("LT"),
            sortidxFrom: tmpSortIdxFrom,
            sortidxTo: tmpSortIdxTo,
          });
        }

        if (item.to) {
          tmpCurrentTime = item.to;
        } else {
          // items without a duration don't have a to time
          tmpCurrentTime = item.from;
        }
      });

    return timeslots;
  },

  dayplanner_unfinished_tasks() {
    return $models.userDayplannerTasks.subscribeQuery({
      key: "finished",
      value: false,
      //endAt: moment.currentDate().unix(), //moment.currentDate().clone().subtract(10,'day').format('YYMMDD'), // <<<
      limit: 1000         // <<<
    }).itemsAsArray();
  },
  dayplanner_unfinished_tasks_old: (state, getters) => {
    if (getters.dayplanner_unfinished_tasks) {
      return clonedeep(getters.dayplanner_unfinished_tasks).filter(task => parseInt(task.$state.dateString) < parseInt(moment.currentDate().format('YYMMDD')))
    }
  },

  // ------------------------------------------------------------------------------------------------
  /**
  * Returns hours planned per commitment and per day
  *
  */
  dayplanner_planned_daily_time_by_commitment: (state, getters) => {
    let sessions = getters.dayplanner_sessions
    let result = {};

    sessions.itemsAsArray().forEach(session => {

      let commitmentId = session.commitmentId;
      let duration_in_s = session.to.diff(session.from, 'seconds')
      let dateKey = 'day-' + session.to.format('YYMMDD');

      if ( !( dateKey in result ) ) {
        result[ dateKey ] = {};
      }

      if ( commitmentId in result[ dateKey ] ) {
        result[ dateKey ][ commitmentId ] += duration_in_s;
      } else {
        result[ dateKey ][ commitmentId ] = duration_in_s;
      }
    });

    return result
  },

  /*
  * Returns hours planned per commitment
  *
  * TODO: Only return time until today!?
  *
  */
  dayplanner_planned_time_overall_by_commitment: (state, getters) => {
    let sessions = getters.dayplanner_sessions

    let result = sessions.itemsAsArray().reduce(( accumulator, session ) => {

      let commitmentId = session.commitmentId;
      // let duration_in_s = ( session.to - session.from ) / 1e3;
      let duration_in_s = session.to.diff(session.from, 'seconds')

      if ( !( commitmentId in accumulator ) ) {
        accumulator[ commitmentId ] = 0;
      }

      accumulator[ commitmentId ] += duration_in_s;
      return accumulator;

    }, {});

    //console.log("dayplanner_planned_time_overall_by_commitment", result)
    return result
  },

  // ------------------------------------------------------------------------------------------------
  find_free_timeslot: (state, getters) => {
    // TODO: ...
  },

}
